import React, { useState } from 'react'
import {
  Table,
  Button,
  Spinner,
} from 'reactstrap'
import { FaPencilAlt, FaSave, FaTrash, FaRegEye, FaQuestionCircle } from 'react-icons/fa'
import { useHistory } from 'react-router-dom';

// @Components
import TarjetaContenido from 'components/TarjetaContenido/TarjetaContenido'
import PaginaPorDefecto from './Default'
import { ModalCreditarEncuesta } from 'components/ModalCreditarEncuesta/ModalCreditarEncuesta'
import BuscadorTablas from 'components/Buscador/BuscadorTabla'

// @Hooks
import { useToggle } from 'hooks/useToggle'
import { useEncuesta } from 'hooks/useEncuesta'
import { RUTAS } from 'constants/constants';

const initialValues = {
  auto_evaluacion: '',
  grupo_interes: '',
  titulo: '',
  descripcion: '',
}

export default function Encuesta() {
  /**
   * Hooks
   */
  const { push } = useHistory()

  /**
   * Estado
   */
  const [buscar, setBuscar] = useState('')
  const { open, onToggle } = useToggle()
  const [encuestaSeleccionada, setEncuestaSeleccionada] = useState(initialValues)

  /**
   * Consultas
   */
  const {
    handleBuscarEncuesta,
    handleEliminarEncuesta,
    obtenerEncuestas,
  } = useEncuesta()
  const { data: encuestas } = obtenerEncuestas(buscar)

   /**
   * Manejadores
   */
  const onClosedModal = () => {
    setEncuestaSeleccionada(initialValues)
  }
  
  return (
    <PaginaPorDefecto titulo='Encuestas'>
      <ModalCreditarEncuesta 
        onToggle={onToggle}
        open={open}
        encuesta={encuestaSeleccionada}
        onClosedModal={onClosedModal}
      />
      <TarjetaContenido
        titulo={<span>Listado de encuestas { !encuestas && <Spinner color='primary' style={{ marginLeft: '1rem' }} />}</span>}
        component={
          <Button outline color='primary' onClick={onToggle}>
            <FaSave />
          </Button>
        }
      >
        <BuscadorTablas
          valor={buscar}
          onChange={setBuscar}
          onBuscar={handleBuscarEncuesta}
        />
        <Table responsive>
          <thead>
            <tr>
              <th>Grupo de Interés</th>
              <th>Título</th>
              <th>Descripción</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {encuestas?.results?.length === 0 && (
              <tr>
                <td colSpan={4}>
                  <p className='text-center'>No hay encuestas registradas</p>
                </td>
              </tr>
            )}
            {encuestas && encuestas.results.map((encuesta) => {
              const manejadorEditarEncuesta = () => {
                setEncuestaSeleccionada(encuesta)
                onToggle()
              }

              const manejadorEliminarEncuesta = () => {
                handleEliminarEncuesta(encuesta)
              }

              const manejadorVistaPrevia = () => {
                push(RUTAS.VISTA_PREVIA_ENCUESTA.replace(':id', encuesta.id))
              }

              const manejadorAñadirPreguntas = () => {
                push(RUTAS.DETALLE_ENCUESTA.replace(':id', encuesta.id))
              }
              return (
              <tr key={encuesta.id}>
                <td>{encuesta.grupo_interes.nombre}</td>
                <td>{encuesta.titulo}</td>
                <td>{encuesta.descripcion}</td>
                  <td className='d-flex'>
                    <span title="Vista previa">
                      <Button
                        outline
                        color='primary'
                        size='sm'
                        className='mr-1'
                        onClick={manejadorVistaPrevia}
                      >
                        <FaRegEye />
                      </Button>
                    </span>
                    <span title="Añadir preguntas">
                      <Button
                        outline
                        color='primary'
                        size='sm'
                        className='mr-1'
                        onClick={manejadorAñadirPreguntas}
                      >
                        <FaQuestionCircle />
                      </Button>
                    </span>
                    <span title="Editar">
                      <Button
                        outline
                        color='primary'
                        size='sm'
                        className='mr-1'
                        onClick={manejadorEditarEncuesta}
                      >
                        <FaPencilAlt />
                      </Button>
                    </span>
                    <span title="Eliminar">
                      <Button
                        outline
                        color='danger'
                        size='sm'
                        onClick={manejadorEliminarEncuesta}
                      >
                        <FaTrash />
                      </Button>
                    </span>
                </td>
              </tr>
            )})}
          </tbody>
        </Table>
      </TarjetaContenido>
    </PaginaPorDefecto>
  )
}
